import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';

export default function Text({
  className = '',
  disabled = false,
  errorIcon = null,
  // eventName = 'user_input',
  hideLabel = false,
  input = {},
  inputProps = {},
  isErrorField = false,
  isNumber = false,
  meta = {},
  // recordEvent = true,
  required = false,
  serverError = '',
  showErrorWithoutTouched = false,
}) {
  const { touched, error: clientError } = meta;
  const error = clientError || serverError;

  const label = `${input.value}` && !hideLabel;
  const notEmpty = label ? styles['not-empty'] : '';
  const isError =
    (touched && error && !showErrorWithoutTouched) || isErrorField
      ? styles.isError
      : '';
  const isErrorNoTouched =
    error && showErrorWithoutTouched ? styles.isError : '';
  const classes = [
    styles.root,
    className,
    notEmpty,
    isError,
    isErrorNoTouched,
    disabled ? styles.disabled : '',
  ]
    .filter(Boolean)
    .join(' ');

  const blockInvalidChar = (e) => {
    if (
      ![
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'Backspace',
        'ArrowLeft',
        'ArrowRight',
        'Control',
        'Tab',
      ].includes(e.key)
    ) {
      e.preventDefault();
    }
  };

  return (
    <div className={styles.containerField}>
      {inputProps.label && (
        <label className={styles.label}>{inputProps.label}</label>
      )}
      {required && <span className={styles.withAsterisk}> *</span>}
      <div className={classes}>
        <span>
          {
            <img
              alt="icon-text-field"
              onError={({ currentTarget }) => {
                currentTarget.remove();
              }}
              src={`assets/${inputProps.icon}`}
            />
          }
        </span>
        <input
          className={styles['input-field']}
          disabled={disabled}
          {...input}
          {...inputProps}
          onKeyDown={isNumber ? blockInvalidChar : () => { }}
        />
      </div>
      {error && (showErrorWithoutTouched || touched || (!clientError && serverError)) && (
        <span className={styles.error}>
          {errorIcon && <>{errorIcon}&nbsp;</>}
          {error}
        </span>
      )}
    </div>
  );
}

Text.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorIcon: PropTypes.node,
  eventName: PropTypes.string,
  hideLabel: PropTypes.bool,
  input: PropTypes.object,
  inputProps: PropTypes.object,
  isErrorField: PropTypes.bool,
  isNumber: PropTypes.bool,
  meta: PropTypes.object,
  recordEvent: PropTypes.bool,
  required: PropTypes.bool,
  serverError: PropTypes.string,
  showErrorWithoutTouched: PropTypes.bool,
};
